<template>
  <section class="bg-light">
    <div class="row" :class="{ 'no-gutters' : $mq.phone }">
      <div class="col-12 col-lg-6 offset-lg-3">
        <!-- BeNeat Rewards Points -->
        <div class="row pt-3">
          <div class="col-12">
            <div class="card shadow-sm">
              <div class="card-body">
                <b>{{ $t('message.rewards.your_points') }}</b>
                <div class="d-flex justify-content-start align-items-center mt-2 ">
                  <div>
                    <i class="fas fa-trophy-alt -status-pending fa-2x"></i>
                  </div>
                  <div class="ml-4">
                    <h1 class="d-inline-block mb-0">{{ totalPoints | prettyNumber }}</h1>
                    <span class="text-secondary">{{ $t('message.rewards.points') }}</span>
                  </div>
                </div>
                <div class="mt-2 text-remark text-secondary" v-if="userPointGroups && userPointGroups.length">
                  <div v-for="userPointGroup in userPointGroups">
                    <span>{{ userPointGroup.points | prettyNumber }} {{ $t('message.rewards.points_will_expire_date') }} {{ userPointGroup.expire_date | prettyOnlyDate }}</span>
                  </div>
                </div>
                
                <hr>
                <div class="d-flex justify-content-start align-items-center">
                  <div class="flex-grow-1">
                    <b>{{ $t('message.rewards.how_it_works') }}</b>
                  </div>
                  <div>
                    <a href="" class="text-dark" @click.prevent="visible = !visible">
                      <i class="fas fa-angle-down" v-if="visible === false"></i>
                      <i class="fas fa-angle-up" v-else></i>
                    </a>
                  </div>
                </div>
               
                <b-collapse id="collapse-1" v-model="visible" class="mt-2" v-if="rewardInfo">
                  <div class="text-small" v-html="rewardInfo.earning_point_conditions.detail_th" v-if="$i18n.locale === 'th'"></div>
                  <div class="text-small" v-html="rewardInfo.earning_point_conditions.detail_en" v-else></div>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
        

        <!-- Menus -->
        <div class="row">
          <div class="col-6">
            <router-link to="/user-rewards" class="text-info">
              <div class="card shadow-sm">
                <div class="card-body text-center">
                  <i class="fas fa-gift fa-lg"></i>
                  <div class="pt-3 text-dark"><label>{{ $t('message.rewards.my_redeemed_rewards') }}</label></div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="col-6">
            <router-link to="/user-points" class="text-info">
              <div class="card shadow-sm">
                <div class="card-body text-center">
                  <i class="fas fa-clock fa-lg"></i>
                  <div class="pt-3 text-dark"><label>{{ $t('message.rewards.points_history') }}</label></div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- List of rewards -->
    <div class="container pt-3" v-if="rewards">
      <div class="row">
        <div class="col-12" :class="{ 'p-0' : $mq.phone }">
          <h3 class="mb-0">{{ $t('message.rewards.list') }}</h3>
        </div>
        <div class="col-lg-6 col-12" :class="{ 'p-0' : $mq.phone }" v-for="(reward, index) in rewards" :key="index">
          <router-link class="no-style" :to="`/rewards/${reward.id}`">
            <div class="card shadow-sm">
              <div class="card-body p-3">
                <div class="d-flex flex-row">
                  <div class="w-50">
                    <img :src="reward.image_url" alt="" class="img-fluid rounded">
                  </div>
                  <div class="w-50 pl-3 pt-2">
                    <div class="d-flex flex-column">
                      <h3 class="mb-2">{{ ($i18n.locale === 'th') ? reward.title_th : reward.title_en }}</h3>
                      <div class="text-secondary text-small">
                        {{ $t('message.rewards.redeem_by') }} <h4 class="d-inline-block">{{ reward.end_date | prettyOnlyDate }}</h4>
                      </div>
                      <div class="mt-4 text-right">
                        <h4 class="d-inline-block text-info">{{ reward.points | prettyNumber }}</h4>
                        <span class="text-secondary text-small">{{ $t('message.rewards.points') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex'

  export default {
    data () {
      return {
        visible: false
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      }),
      ...mapState('reward', ['rewards', 'rewardInfo', 'totalPoints', 'userPointGroups'])
    },
    methods: {
      ...mapActions('reward', ['fetchRewards'])
    },
    mounted () {
      if (this.user) {
        const params = {
          user_id: this.user.id,
          page: 0
        }
        this.fetchRewards(params)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/reward/Index.vue